export default "__VITE_ASSET__Z1TnyPHh__"